import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { useDispatch, useSelector } from 'react-redux';
import { contractGeneratorOperations, contractGeneratorSelectors } from 'Redux/ducks/contractGenerator';
import useFirstRender from 'ViatoUi/Shared/Utilities/useFirstRender';

const Captcha = ({ forceReset }) => {
	const dispatch = useDispatch();
	const recaptchaRef = React.createRef();
	const firstRender = useFirstRender();

	const { CAPTCHA_CLIENT } = useSelector(contractGeneratorSelectors.getConstants);

	useEffect(() => {
		if (forceReset !== 0 && !firstRender) {
			recaptchaRef.current.reset();
		}
		dispatch(contractGeneratorOperations.setDataToSubmit({ captchaResponse: '' }));
	}, [forceReset]);

	return (
		<ReCAPTCHA
			ref={recaptchaRef}
			sitekey={CAPTCHA_CLIENT}
			onChange={value => dispatch(contractGeneratorOperations.setDataToSubmit({ captchaResponse: value }))}
		/>
	);
};

Captcha.propTypes = {
	forceReset: PropTypes.number
};

Captcha.defaultProps = {
	forceReset: 0
};

export default Captcha;
